<div role="group" class="phone-number-input-container" [formGroup]="parts" [attr.aria-labelledby]="_formField.getLabelId()">
    <span class="phone-number-input-spacer">(</span>
    <input
        class="phone-number-input-element"
        style="width: 32px"
        formControlName="area"
        maxLength="3"
        aria-label="Area code"
        (input)="_handleInput(parts.controls.area, office)"
        #area
        type="tel"
        appNumberOnly
    />
    <span class="phone-number-input-spacer">)</span>
    <input
        class="phone-number-input-element"
        style="width: 32px; margin-left: 2px"
        formControlName="office"
        maxLength="3"
        aria-label="Office code"
        (input)="_handleInput(parts.controls.office, subscriber)"
        (keyup.backspace)="autoFocusPrev(parts.controls.office, area)"
        #office
        type="tel"
        appNumberOnly
    />
    <span class="phone-number-input-spacer">&ndash;</span>
    <input
        class="phone-number-input-element"
        formControlName="subscriber"
        style="width: 40px; text-align: left"
        maxLength="4"
        aria-label="Subscriber number"
        (input)="_handleInput(parts.controls.subscriber)"
        (keyup.backspace)="autoFocusPrev(parts.controls.subscriber, office)"
        #subscriber
        type="tel"
        appNumberOnly
    />
</div>
